import { useMemo } from 'react';
import { LabelBodyHeadline } from '../features/modules/components';

type Props = {
    min: number;
    max: number;
    step?: number;
    hideZeroLabel?: boolean;
    disabled?: boolean;
};
export function SliderMarkerLabels({
    min,
    max,
    step = 1,
    hideZeroLabel = false,
    disabled = false,
}: Props) {
    const labels = useMemo(() => {
        const array = [];
        for (let i = min; i <= max; i += step) {
            array.push(i);
        }
        return array;
    }, [min, max, step]);

    return (
        <LabelBodyHeadline
            className={`flex justify-between px-10 ${disabled ? 'text-grey-textfield-placeholder' : 'text-dark-red'}`}
        >
            {labels.map((rangeValue) => (
                <span
                    key={rangeValue}
                    className={
                        hideZeroLabel && rangeValue === 0 ? 'invisible' : ''
                    }
                >
                    {rangeValue}
                </span>
            ))}
        </LabelBodyHeadline>
    );
}
